import React, { Component } from 'react';
import { Layout } from 'antd';
import Routes from '../routes';
import SiderMenu from '@components/SiderMenu';
import CustomHeader from '@components/CustomHeader';
import Loading from '@components/Loading';
import bus from '@utils/bus';
import { getAllChannel } from "@api/user";


const { Content } = Layout;

class App extends Component {
    state = {
        isLoading: false,
    };

    cnt = 0

    componentDidMount() {
        bus.subscribe('loadingChange', this.handleLoadingChange.bind(this));
        this.getAllChannel()
    };

    componentWillUnmount() {
        bus.unSubscribe(['loadingChange'])
    };

    async getAllChannel() {
        const channel = await window.$cache.get('channel')
        console.log(channel);
        if (channel != null) {
            return
        }
        // get tree from remote
        getAllChannel()
            .then(async (res) => {
                console.log('所有渠道信息',res.data.data);
                if (res.data.data != null) {
                    await window.$cache.set('channel', res.data.data, 1 * 24 * 60 * 60);
                }
            })
    }

    handleLoadingChange(isShow) {
        this.cnt += isShow ? 1 : -1;
        // console.log(this.cnt, isShow);
        this.setState({
            isLoading: this.cnt > 0
        });
    };

    render() {
        return (
            <div className="App">
                <Loading isLoading={this.state.isLoading} />
                <Layout>
                    <SiderMenu />
                    <Layout>
                        <CustomHeader />
                        <Content style={{ margin: '64px 16px', overflow: 'initial', flex: '1 1 0' }}>
                            <Routes />
                        </Content>
                    </Layout>
                </Layout>
            </div>
        );
    }
}

export default App;